import BaseModal from "../BaseModal/BaseModal";
import Comment from "../../components/CommentBox/Comment";

export default function NotificationCommentModal({className, comment, isOpen, setOpen, ...props}) {

    return (
        <BaseModal innerClassName={"lg:w-1/2 overflow-auto"} isBoxOpen={isOpen} autoClose={false} defaultHeader={true}
                   title={"Comment"}
                   setIsBoxOpen={setOpen}>
            <div className={"py-8 overflow-auto"}>
                <Comment comment={comment} onlyViewMode={true}/>

            </div>
        </BaseModal>

    )
}